// Liste complète des genres de jeux vidéo
// Basée sur les catégories Steam et les genres populaires
export const GAME_GENRES: string[] = [
  // Action & Aventure
  "Action",
  "Action RPG",
  "Adventure",
  "Beat 'em up",
  "Fighting",
  "Hack and Slash",
  "Platformer",
  "Stealth",
  "Survival",
  "Survival Horror",

  // Stratégie
  "Real-Time Strategy (RTS)",
  "Turn-Based Strategy",
  "Tower Defense",
  "4X Strategy",
  "Grand Strategy",
  "City Builder",
  "Management",
  "Simulation",

  // Simulation
  "Life Simulation",
  "Vehicle Simulation",
  "Flight Simulation",
  "Space Simulation",
  "Farming Simulation",
  "Business Simulation",
  "Sports Simulation",

  // RPG
  "RPG",
  "JRPG",
  "Western RPG",
  "Roguelike",
  "Roguelite",
  "Dungeon Crawler",
  "MMORPG",

  // FPS & TPS
  "First-Person Shooter (FPS)",
  "Third-Person Shooter (TPS)",
  "Tactical Shooter",
  "Battle Royale",
  "Hero Shooter",

  // Sports & Racing
  "Racing",
  "Sports",
  "Football/Soccer",
  "Basketball",
  "Tennis",
  "Golf",
  "Baseball",
  "Hockey",
  "Wrestling",
  "Boxing",
  "Martial Arts",
  "Extreme Sports",

  // Puzzle & Casual
  "Puzzle",
  "Match-3",
  "Hidden Object",
  "Point & Click",
  "Visual Novel",
  "Interactive Fiction",
  "Educational",
  "Trivia",
  "Card Game",
  "Board Game",
  "Party Game",

  // Sandbox & Création
  "Sandbox",
  "Open World",
  "Crafting",
  "Building",
  "Creative",
  "Art Game",

  // Multiplayer
  "Multiplayer",
  "Co-op",
  "Competitive",
  "Team-Based",
  "Massively Multiplayer",
  "Local Multiplayer",
  "Online Multiplayer",

  // Indie & Niche
  "Indie",
  "Retro",
  "Pixel Art",
  "2D",
  "3D",
  "Side-Scroller",
  "Top-Down",
  "Isometric",

  // Thématiques
  "Horror",
  "Psychological Horror",
  "Sci-Fi",
  "Fantasy",
  "Medieval",
  "Historical",
  "Post-Apocalyptic",
  "Cyberpunk",
  "Steampunk",
  "Western",
  "Noir",
  "Mystery",
  "Thriller",
  "Drama",
  "Comedy",
  "Romance",

  // Mécaniques spéciales
  "Metroidvania",
  "Souls-like",
  "Twin-Stick Shooter",
  "Bullet Hell",
  "Rhythm",
  "Music",
  "Dance",
  "Fitness",
  "VR",
  "Augmented Reality",

  // Plateformes & Styles
  "Mobile",
  "Browser Game",
  "Free-to-Play",
  "Early Access",
  "Beta",
  "Demo",
  "Mod",
  "Total Conversion",

  // Autres
  "Casual",
  "Hardcore",
  "Narrative",
  "Story Rich",
  "Character Customization",
  "Character Progression",
  "Skill-Based",
  "Time Management",
  "Resource Management",
  "Trading",
  "Economy",
  "Diplomacy",
  "Warfare",
  "Exploration",
  "Discovery",
  "Collection",
  "Achievement Hunting",
  "Speedrun",
  "Challenge",
  "Relaxing",
  "Meditative",
  "Atmospheric",
  "Immersive",
  "Cinematic",
  "Theatrical",
  "Experimental",
  "Abstract",
  "Minimalist",
  "Maximalist",
  "On-screen",
  "+18",
  "Dystopian",
  "Procedural Generation",
  "Adult",
  "Open-World RPG",
  "Chill",
  "Cosy",
  "Cute",
  "Pirate",
  "Animal",
  "Zombie",
  "Alien",
  "Vampire",
  "Werewolf",
  "Wizard",
  "Typing",

  // Festival
  "Spelling",
  "Word Game",
  "MOBA",
  "Horses",
  "Equestrian",
  "Farming Sim",
  "Nature",
  "Base Building",
  "RTS",
  "Design",
  "Decoration",
  "Life Sim",
  "Renovation",
  "Sword & Shield",
  "Deckbuilder",
  "Card Battler",
  "Roguelike Deckbuilder",
  "Underwater",
  "Naval",
  "Submarine",
  "Fishing",
  "Sea",
  "Sailing",
  "Shoot 'em up",
  "Shmup",
  "Top-Down Shooter",
  "Arcade",
  "Social Deduction",
  "Detective",
  "Trains",
  "Transportation",
  "Logistics",
  "Hacking",
  "Transhumanism",
  "Bowling",
  "Pinball",
  "Pachinko",
  "Physics",
  "Tabletop",
  "PvP",
  "Arena",
  "Riding",
  "Animal Sim",
  "Tactical",
  "Cozy",
  "Investigation",
  "Knight",
  "Castle",
  "Trading Card Game",
  "Marine Life",
  "Bullet Heaven",
  "Survivor-like",
  "Traitor",
  "Railway",
  "Driving",
  "Futuristic",
  "Neon",
  "Precision",
  "Open World Survival Craft",
  "PvE",
  "Programming",
  "Logic",
  "Automation",
  "CRPG",
  "Party-Based RPG",
  "Turn-Based Combat",
  "Squad-Based",
  "Tactical RPG",
  "Cooking",
  "Restaurant",
  "Farming",
  "Dark",
  "Vampires",
  "Supernatural",
  "Auto Battler",
  "Auto Chess",
  "Idle",
];

// Type pour TypeScript
export type GameGenre = typeof GAME_GENRES[number];

// Fonction utilitaire pour parser les genres depuis la base de données
export const parseGenres = (genresString: string): string[] => {
  if (!genresString) return [];
  return genresString.split(',').map(genre => genre.trim()).filter(Boolean);
};

// Fonction utilitaire pour formater les genres pour la base de données
export const formatGenres = (genres: string[]): string => {
  return genres.filter(Boolean).join(',');
};

// Fonction de recherche dans les genres
export const searchGenres = (query: string): string[] => {
  if (!query.trim()) return GAME_GENRES;
  const lowercaseQuery = query.toLowerCase();
  return GAME_GENRES.filter(genre =>
    genre.toLowerCase().includes(lowercaseQuery)
  );
};
